// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-edit-cms-content[data-v-428dace1]{display:flex;align-items:center;justify-content:center;position:fixed;bottom:10px;left:10px;width:50px;height:50px;border-radius:100%;background:var(--primary);cursor:pointer}.button-edit-cms-content img[data-v-428dace1]{filter:invert(1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
